/* src/app/ship/components/delivery-defense/remaining-credits/dd-remaining-credits.component.scss */
.credit-row {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  column-gap: 15px;
}
.credit-row .credit-column {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  justify-content: space-between;
}
.credit-row .credit-column:first-of-type {
  flex: 2;
}
.credit-row .credit-column:last-of-type {
  flex: 1;
}
.credit-description {
  font-size: 1.0625em;
  font-weight: 700;
  margin-left: auto;
}
.credits {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: flex-start;
  font-weight: 700;
}
.credits .current-credits {
  font-size: 1.875em;
  width: auto;
  height: 1em;
  line-height: 1.25;
}
.credits .full-credits {
  font-size: 1em;
}
.credits .full-credits::before {
  content: "/";
}
.credit-cta {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-size: 0.56em;
  font-weight: 400;
}
.credit-cta.disabled {
  color: #AFB1BF;
  pointer-events: none;
}
.credit-cta:hover {
  text-decoration: none;
}
.credit-cta .mat-icon {
  font-size: 1.3rem;
  width: 1.3rem;
  height: 1.3rem;
  margin-right: 0.25rem;
}
.credit-cta span {
  text-decoration: underline;
}
:host(.dd-remaining-credits) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  height: auto;
  padding: 0 1.125rem 1.125rem 1.125rem;
  row-gap: 1rem;
}
/*# sourceMappingURL=dd-remaining-credits.component.css.map */
